import { EventEmitter, Injectable } from '@angular/core';
import { ElementRoute, PrimaryKeySetting } from 'dbweb-core';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { startWith, tap } from 'rxjs/operators';
import { BillComponent } from '../../bill/bill.component';
import { ModelElementCategory } from '../../services/eleview/eleview-backface';
import { map2WithLetter } from '../../services/eleview/mapletter';
import { ColumnsWithLetter } from '../../services/eleview/types/model';
import { Controller, ElementBackFace, MainColumn } from './back-face';
import { BillParam, FieldSetting, FillAt } from './bill-param';
import { ImportParam, ImportField, ImportStyle } from './import-param';
import { ConditionalTemplate, RecordViewParam } from './recordview-param';
import { UpdateParam } from './update.param';

interface IElementData {
	Tabs: string[];
	parent: ElementService;
}
export interface IProcess {
	Name: string;
	Icon?: string; // [namespace]:[name] çæ¹å¼
	Color?: string; // è°è²æ¿è²å·åç§°ï¼é»è®¤ä¸ºç©º
	ElementName?: string;
	BindRecord: boolean; // ä¼ éå°ä¸ä¸ä¸ªå·¥ä½åç´ çè·¯å¾ä¸ï¼ä¸è¬ç¨æ¥ä¼ éä¸»é®ï¼å¦æä¸ºç©ºåèªå¨ä¼ éè¡¨çä¸»é®
	TransPath?: string[]; // ä¼ éå°ä¸ä¸ä¸ªå·¥ä½åç´ çåæ°ï¼ç¨æ¨¡æ¿æ¥å®æ,
	TransQuery?: string; // ä¸è¬æ¯ç¨æ¥ä¼ éå°å¦ä¸ä¸ªRecordViewçéå æ¡ä»¶åæ é¢
	WithSql?: boolean; // æ¯å¦ä¼ ésql
	Visable?: string; // éç©ºçè¯è®¡ç®å¯è§æ§ï¼ç¨templaterçè¯­æ³
	MoreStr?: string;
}

export class ElementDataRecordView implements IElementData {
	labelCategories: ModelElementCategory[];
	Tabs = ['åæ°SQL', 'é»è®¤æ¾ç¤ºå', 'å¤çåè¡¨', 'æ ç­¾', 'æ¡ä»¶æ¨¡æ¿'];
	DBList: string[];
	Tables: string[];
	allElementNames: string[];
	SQLCheckError: string;
	allColumnNames: string[];
	allColumnWithLetter: ColumnsWithLetter[];
	// ä»params.processesä¸­è½¬æ¢èæ¥
	bindRecordProcesses: IProcess[];
	notBindRecordProcesses: IProcess[];
	inited = new EventEmitter();
	get Params() {
		return this.parent.Params as RecordViewParam;
	}
	currentProcess = new BehaviorSubject<IProcess>(null);
	currentConditionTemplate: ConditionalTemplate;
	constructor(public parent: ElementService) {}
	init() {
		forkJoin([
			this.parent.back.fetchDB(),
			this.parent.back.fetchElementNames(),
			this.parent.back.fetchTables(this.Params.DB)
		]).subscribe(v => {
			this.DBList = v[0];
			this.allElementNames = v[1];
			this.Tables = v[2];

			this.refreshProcesses();
			if (this.bindRecordProcesses && this.bindRecordProcesses.length > 0) {
				this.currentProcess.next(this.bindRecordProcesses[0]);
			} else if (this.notBindRecordProcesses && this.notBindRecordProcesses.length > 0) {
				this.currentProcess.next(this.notBindRecordProcesses[0]);
			}
			if (this.Params.ConditionalTemplates && this.Params.ConditionalTemplates.length > 0) {
				this.currentConditionTemplate = this.Params.ConditionalTemplates[0];
			}
			this.checkSQL().subscribe();

			this.inited.emit();
		});
	}
	public refreshTables() {
		this.parent.back.fetchTables(this.Params.DB).subscribe(v => (this.Tables = v));
	}
	public refreshProcesses() {
		this.bindRecordProcesses = (this.Params.Processes || []).filter(v => v.BindRecord);
		this.notBindRecordProcesses = (this.Params.Processes || []).filter(v => !v.BindRecord);
	}

	// å°åå¼çå¤çåè¡¨åå¹¶æä¸ä¸ª
	collectionProcesses() {
		this.Params.Processes = [...this.bindRecordProcesses, ...this.notBindRecordProcesses];
	}

	checkSQL() {
		return this.parent.back
			.checkSQL({
				DB: this.Params.DB,
				Table: this.Params.TableName,
				ManualPage: this.Params.ManualPage,
				SQL: this.Params.Sql
			})
			.pipe(
				tap(v => {
					this.SQLCheckError = v.Error;
					if (!this.SQLCheckError) {
						// è¦ææ§çç±»åå¤å¶è¿æ¥
						this.Params.AllColumns = v.Columns.map(col => {
							let t = col.Type;
							if (this.Params.AllColumns) {
								const oldCol = this.Params.AllColumns.find(fv => fv.Name === col.Name);
								if (oldCol) {
									t = oldCol.Type;
								}
							}
							return {
								Name: col.Name,
								Type: t
							};
						});
						this.allColumnNames = this.Params.AllColumns.map(vv => vv.Name);
						this.allColumnWithLetter = map2WithLetter(this.allColumnNames);
						// å é¤ä¸å­å¨çå
						if (this.Params.Columns) {
							this.Params.Columns = this.Params.Columns.filter(col =>
								this.allColumnNames.includes(col.Name)
							);
						}
					}
				})
			);
	}
}

export class ElementDataImport implements IElementData {
	Tabs: string[] = ['å­æ®µè®¾ç½®', 'å±æ§'];
	constructor(public parent: ElementService) {}
	DBList: string[];
	Tables: string[];
	get Params() {
		return this.parent.Params as ImportParam;
	}

	init() {
		return forkJoin([this.parent.back.fetchDB(), this.parent.back.fetchTables(this.Params.DB)]).pipe(
			tap(v => {
				this.DBList = v[0];
				this.Tables = v[1];
				this.syncTableColumn();
			})
		);
	}
	// æ ¹æ®è¡¨åï¼åæ­¥ææ°çå­æ®µæ¸å
	syncTableColumn() {
		this.parent.back.fetchTableColumns(this.Params.Table).subscribe(v => {
			this.Params.Fields = v.map(one => {
				const found = this.Params.Fields.find(sv => sv.Name === one);
				if (found) {
					return found;
				}
				return {
					Name: one,
					Style: ImportStyle.Normal
				} as ImportField;
			});
		});
	}
	refreshTables() {
		this.parent.back.fetchTables(this.Params.DB).subscribe(v => {
			this.Tables = v;
		});
	}
}

export class ElementDataUpdate implements IElementData {
	Tabs: string[] = ['è®¾ç½®'];
	DBList: string[];
	Tables: string[];
	constructor(public parent: ElementService) {}
	get Params() {
		return this.parent.Params as UpdateParam;
	}
	isAllSelected() {
		return this.Params.Fields && this.Params.Fields.find(v => !v.selected) === undefined;
	}
	hasSelected() {
		return this.Params.Fields && this.Params.Fields.find(v => v.selected) !== undefined;
	}

	init() {
		this.parent.back.fetchDB().subscribe(v => (this.DBList = v));
		this.refreshTables();
	}
	refreshTables() {
		this.parent.back.fetchTables(this.Params.DB).subscribe(v => (this.Tables = v));
	}
}
export class ElementDataBill implements IElementData {
	Tabs = ['è®¾ç½®'];
	MainColumns: MainColumn[];
	get Param() {
		return this.parent.Params as BillParam;
	}
	fixFieldSettings(cols: string[]) {
		this.Param.FieldSettings = cols.map(col => {
			let foundField: FieldSetting;
			if (this.Param && this.Param.FieldSettings) {
				foundField = this.Param.FieldSettings.find(fld => fld.Name === col);
			}
			if (foundField) {
				return foundField;
			}
			return {
				Name: col,
				Fill: '',
				FillAt: FillAt.SkipFill,
				Visibility: ''
			} as FieldSetting;
		});
	}
	fixCloneSettings() {
		const old = [...(this.Param.ClonePrimaryKeySettings || [])];
		if (this.Param.AllowClone) {
			this.Param.ClonePrimaryKeySettings = this.MainColumns.filter(v => v.PrimaryKey).map(v => {
				const oldField = old.find(o => o.Name === v.Name);
				return {
					Name: v.Name,
					Fill: oldField ? oldField.Fill : '{{.SRC}}',
					Visibility: oldField ? oldField.Visibility : ''
				} as PrimaryKeySetting;
			});
			console.log(this.Param.ClonePrimaryKeySettings);
		} else {
			this.Param.ClonePrimaryKeySettings = null;
		}
	}
	constructor(public parent: ElementService) {
		this.parent.init.subscribe(() => {
			this.parent.bill.formGroup
				.get('Controller')
				.valueChanges.pipe(startWith(this.parent.bill.formGroup.get('Controller').value))
				.subscribe(v => {
					// å¦ææ¯åæ®ï¼åéè¦ä¿®å¤å¡«ååçè®¾ç½®
					const ctrl = this.parent.Controllers.find(c => c.Name === v);
					if (ctrl && ctrl.Bill) {
						this.parent.back.fetchBillMainColumns(v).subscribe(cols => {
							this.MainColumns = cols;
							this.fixFieldSettings(cols.map(c => c.Name));
							this.fixCloneSettings();
						});
					}
				});
		});
	}
}
@Injectable()
export class ElementService {
	bill: BillComponent;
	init = new EventEmitter();
	Controllers: Controller[];
	Categories: string[];
	CategoriesEN: string[];
	BaseActive = true;
	ActiveTab: string;
	Roles: {
		Name: string;
		Checked: boolean;
		OldChecked: boolean;
	}[];
	Params: any;
	data: { [key: string]: IElementData } = {
		recordview: new ElementDataRecordView(this),
		import: new ElementDataImport(this),
		update: new ElementDataUpdate(this),
		bill: new ElementDataBill(this)
	};
	constructor(public back: ElementBackFace) {}
	onInit(ele: ElementRoute) {
		this.back.element = ele;
		this.back.fetchElementInitData(this.bill.typeRecord.Name).subscribe(v => {
			this.Controllers = v.Controllers;
			this.Categories = v.Categories;
			this.CategoriesEN = v.CategoriesEN;
			if (v.CanSelectRoles) {
				this.Roles = v.CanSelectRoles.map(sv => ({
					Name: sv,
					OldChecked: v.Roles && v.Roles.find(vv => vv === sv) !== undefined,
					Checked: false,
					Modify: false
				}));
				this.Roles.forEach(role => (role.Checked = role.OldChecked));
			}
			this.init.emit();
		});
	}
}
